type Languages = "en" | "da" | "fo";

const currentLanguage: Languages = "fo";

const translations = {
  titleAnnuity: {
    en: "Loan calculator",
    fo: "Lánroknari",
    da: "Låneberegner",
  },
  subtitleAnnuity: {
    en: "Calculate the monthly rate below; also after interest subsidy",
    fo: "Rokna mánaðarliga gjaldið, eisini eftir rentustuðul, niðanfyri",
    da: "Beregn den månedlige ydelse, også med rentestøtte, nedenfor",
  },
  titleSavings: {
    en: "I'm saving up",
    fo: "Eg spari upp",
    da: "Jeg sparer op",
  },
  desiredSavings: {
    en: "Desired savings",
    fo: "Ynskt uppsparing",
    da: "Ønsket opsparing",
  },
  savingsAfterXPercentInterestTax: {
    en: "Savings after {{ x }}% interest tax",
    fo: "Uppsparing eftir {{ x }}% rentuskatt",
    da: "Opsparing efter {{ x }}% renteskat",
  },
  savingsInXYears: {
    en: "Savings in {{ x }} years",
    fo: "Uppsparing um {{ x }} ár",
    da: "Opsparing om {{ x }} år",
  },
  descriptionAnnuity: {
    en: "Calculate the monthly rate below; also after interest subsidy",
    fo: (
      <p>
        LánRoknarin er fleksibul, og minnst tí til fylgjandi:
        <ul>
          <li>
            <em>Rentustuðul</em>
            <ul>
              <li>verður bert veittur fyri lán til egnan bústað</li>
              <li>verður bert veittur fyri rentur upp til 100.000 kr/ár</li>
              <li>er í løtuni 35%</li>
              <li>
                les meiri um rentustuðul{" "}
                <a href="https://www.ss.fo/rentustudul">her</a>
              </li>
            </ul>
          </li>
          <li>
            <em>Rentan</em>
            <ul>
              <li>er altíð skiftandi</li>
              <li>verður bert veittur fyri rentur upp til 100.000 kr/ár</li>
              <li>
                fyri lán upp til 80% av virðinum av ognini fært tú ta bíligastu
                rentuna, sum eitur 1. veðrættar rentan, í løtuni 4,14% p.a.
              </li>
              <li>
                tørvar tær at læna meiri enn 80% av virðinum av ognini, er
                rentan hægri sum 2. veðrættar renta, í løtuni úr 5,xx% p.a.
              </li>
            </ul>
          </li>
          <li>
            <em>Áramal</em>
            <ul>
              <li>Mest vanliga afturgjaldstíðin fyri 1. veðrætt er 25 ár</li>
              <li>fyri 2. veðrættin 20 ár</li>
              <li>men tosa við okkum fyri at hoyra nærri um møguleikarnar</li>
            </ul>
          </li>
        </ul>
      </p>
    ),
    da: "Beregn den månedlige ydelse, også med rentestøtte, nedenfor",
  },
  loanAmount: {
    en: "Loan amount",
    fo: "Lánsupphædd",
    da: "Lånebeløb",
  },
  perMonth: {
    en: "Per month",
    fo: "Um mánaðin",
    da: "Per måned",
  },
  interestTax: {
    en: "Interest tax",
    da: "Renteskat",
    fo: "Rentuskatt",
  },
  duration: {
    en: "Duration",
    fo: "Áramál",
    da: "Varighed",
  },
  interest: {
    en: "Interest",
    fo: "Renta",
    da: "Rente",
  },
  monthlyRate: {
    en: "Monthly rate",
    fo: "Mánaðarligt gjald",
    da: "Månedlig ydelse",
  },
  monthlyRateAfterXPercentInterestTax: {
    en: "Monthly rate after {{ x }}% interest tax",
    fo: "Mánaðarligt gjald eftir {{ x }}% rentuskatt",
    da: "Månedlig ydelse efter {{ x }}% renteskat",
  },
  accrual: {
    en: "accrual",
    fo: "tilskrivning",
    da: "tilskrivning",
  },
  accruals: {
    en: "accruals",
    fo: "tilskrivningar",
    da: "tilskrivninger",
  },
  accrualsPerYear: {
    en: "Accruals per year",
    fo: "Rentutilskrivingar pr. ár",
    da: "Rentetilskrivninger pr. år",
  },
  paymentsPerYear: {
    en: "Payments per year",
    fo: "Gjøld pr. ár",
    da: "Ydelser pr. år",
  },
  time: {
    en: "time",
    fo: "ferð",
    da: "gang",
  },
  times: {
    en: "times",
    fo: "ferðir",
    da: "gange",
  },
  year: {
    en: "yr",
    fo: "ár",
    da: "år",
  },
  years: {
    en: "yrs",
    fo: "ár",
    da: "år",
  },
  inflation: {
    en: "Inflation",
    fo: "Prísvøkstur",
    da: "Inflation",
  },
  interestAfterInflation: {
    en: "Interest after inflation",
    fo: "Renta eftir prísvøkstur",
    da: "Rente efter inflation",
  },
  interestAfterInterestTax: {
    en: "Interest after interest tax",
    fo: "Renta eftir rentuskatt",
    da: "Rente efter renteskat",
  },
  monthlyRateWithInflation: {
    en: "Monthly rate with inflation",
    fo: "Mánaðarligt gjald eftir prísvøkstur",
    da: "Månedlig ydelse efter inflation",
  },
  monthlyInterestSubsidy: {
    en: "Interest subsidy, monthly",
    fo: "Rentustuðul, mánaðarliga",
    da: "Rentestøtte, månedlig",
  },
  monthlyRateAfterInterestSubsidy: {
    en: "Monthly rate after interest subsidy",
    fo: "Mánaðarligt gjald eftir rentustuðul",
    da: "Månedlig ydelse efter rentestøtte",
  },
  interestSubsidy: {
    en: "Interest subsidy",
    fo: "Rentustuðul",
    da: "Rentestøtte",
  },
  interestSubsidyDisclaimer: {
    en: "On average, the first year",
    fo: "Í miðal, fyrsta ári",
    da: "Gennemsnitligt, det første år",
  },
  bookMeeting: {
    en: "Book meeting",
    fo: "Bílegg prát",
    da: "Bestil møde",
  },
};

export const translate = (
  key: keyof typeof translations,
  replacements: { [key: string]: number | string } = {}
) => {
  return Object.entries(replacements).reduce(
    (previousValue, [replacementKey, value]) =>
      typeof previousValue === "string"
        ? previousValue.replaceAll(`{{ ${replacementKey} }}`, value.toString())
        : previousValue,
    translations[key][currentLanguage]
  );
};

export default translations;
